export enum DanceEventCreationErrorEnum {
  DATE_PAST = "DATE_PAST"
}
